module.exports = __webpack_public_path__ + "static/media/dispatch_systemmoduleD-img3.c465c4b4.png";